export async function dynamicPromiseAll(promises) {

    await Promise.all(promises);

    let allDone = true;

    for(const promise of promises) {
        const result = await _checkPromiseStatus(promise);
        if(result.state === 'pending') {
            allDone = false;
            break;
        }
        if(result.state === 'rejected') {
            throw result.reason;
            break;
        }
    }

    if(allDone) {
        return true;
    }

    return dynamicPromiseAll(promises);

}

function _checkPromiseStatus(promise) {

    const pending = {
      state: 'pending',
    };
    
    return Promise.race([promise, pending]).then(
        (value) => {
            if (value === pending) {
                return value;
            }
            return {
                state: 'resolved',
                value
                };
            },
        (reason) => ({
            state: 'rejected',
            reason
        })
    );
}
  